import * as React from 'react';
import { Typography, Grid, Paper } from '@mui/material';
import { LTVLIBCATEGORY } from '../../routes/CONSTANTS';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import useImagePreloader from '../../common/utils/useImagePreloader';

const Item = styled(Paper)(({ theme }) => ({
  maxWidth: 350,
  maxHeight: 350,
  minWidth: 150,
  minHeight: 150,
  width: '22vw',
  height: '22vw',
  padding: 0,
  margin: 0,
  borderRadius: 20,
  backgroundColor: theme.palette.primary.main,
}));

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.8rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '2.25rem',
  },
  fontWeight: 1000,
  color: '#fff',
  textShadow: '1px 1px #2e2e2e',
}));

export default function CategoryCard(props) {
  const { categoryId, categoryName, thumbnail, thumbnailMotion } = props;
  useImagePreloader([thumbnail, thumbnailMotion]);
  const categoryURL = LTVLIBCATEGORY.replace(':id', categoryId).replace(
    ':name',
    categoryName
  );

  return (
    <>
      <Link to={categoryURL} style={{ textDecoration: 'none' }}>
        <Item
          sx={{
            backgroundImage: `url(${thumbnail})`,
            backgroundSize: 'auto 100%',
            '&:hover': {
              backgroundImage: `url(${thumbnailMotion})`,
            },
          }}
          elevation={5}
        >
          <Grid
            container
            direction='row'
            justifyContent='center'
            alignItems='flex-end'
            sx={{
              width: '100%',
              height: '100%',
            }}
          >
            <Grid item xs={12}>
              <Title>{categoryName}</Title>
            </Grid>
          </Grid>
        </Item>
      </Link>
    </>
  );
}
